import Grid, { GridProps } from '@mui/material/Grid';

interface Props extends GridProps {}

export const LeftPositionedRow = (props: Props) => {
  return (
    <Grid
      {...props}
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ ...props.sx }}
    />
  );
};
